// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResults-cls1_ds5","cls2":"AutoCompleteResults-cls2_KUs AutoCompleteResults-cls1_ds5"};